import { IReduxState } from 'types/redux';

export const monitoredVehiclesSelector = (state: IReduxState) => state.veta.airsideVehicles;
